import { DatePicker } from "@mui/lab";
import {
  AlertColor,
  Autocomplete,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  IconButton,
  InputAdornment,
  MenuItem,
  Modal,
  TextField,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { globalTheme } from "../../../common/theme";
import createStyles from "@mui/styles/createStyles";
import axios from "axios";
import React, { useImperativeHandle, useMemo } from "react";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { PackingList, PackingListItem } from "./PackingListAccessories";
import { DropDownComboOption } from "../../component/GenericFilter";
import { SnackBarMessage, SnackBarMessageProps } from "../../component/SnackBarMessage";
import { GeneralDialog } from "../../component/GeneralDialog";
import Title from "../../component/Title";
import { GetCustLangIdsByLanguageId, Languages } from "../../../common/Constants";
import moment from "moment";
import { CommonProps } from "../../component/MainContents";
import { CustomDropDown1 } from "../../component/CustomDropDown1";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { GridColumns, GridPreProcessEditCellProps, GridRenderCellParams, GridRowId, GridToolbarContainer, GridValueSetterParams, useGridApiContext } from "@mui/x-data-grid";
import { CustomTablePagination } from "../../component/CustomPagination";
import { Add, Delete, SwitchLeft } from "@mui/icons-material";
import { FormatNumber, Pad } from "../../../common/Formatter";
import { ProductList, ProductListHandle } from "../products/ProductList";
import { ProductListItem } from "../products/ProductAccessories";
import { Customer, CustomerAddressItem, CustomerContactPersonItem } from "../customers/CustomerAccessories";
import { AwayFromZeroRounding, GetNoOfLines, HasDuplicates, ValidateNumber } from "../../../common/CommonFunctions";
import { PackingListViewer, PackingListViewerHandle } from "./PackingListViewer";
import { BranchInfo } from "../branches/BranchAccessories";
import { renewToken } from "../../../services/AuthService";
import { NumberTypes } from "../../../models/enums/NumberType";
import NumberFormat from "react-number-format";
import { CustomerAddress, CustomerAddressHandle } from "../customers/CustomerAddress";
import { CustomerContactPerson, CustomerContactPersonHandle } from "../customers/CustomerContactPerson";
import { BoxSize } from "../boxSizes/BoxSizeAccessories";
import { OpenMode } from "../../../common/Enums";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
  })
);

export interface PackingListSingleHandle {
  Initialise: (mode: OpenMode, packingList: PackingList) => void;
}

export function GetPackingListRegion(packingListNo: string) {
  return packingListNo.substring(4, 6);
}

export const PackingListSingle = React.forwardRef(
  (props: CommonProps, ref: React.Ref<PackingListSingleHandle>) => {
    const style = { ...useStyles(), ...globalTheme() };

    const tinyScreen = useMediaQuery('(max-width:1366px)');
    const smallScreen = useMediaQuery('(max-width:1920px)');
    const normalScreen = useMediaQuery('(max-width:2560px)');

    const [hasError, setHasError] = React.useState(false);

    const singleModalRef = React.useRef<ProductListHandle>(null);
    const viewerModalRef = React.useRef<PackingListViewerHandle>(null);
    const customerAddressModalRef = React.useRef<CustomerAddressHandle>(null);
    const customerContactPersonModalRef = React.useRef<CustomerContactPersonHandle>(null);
    
    const [open, setOpen] = React.useState(false);
    const [openMode, setOpenMode] = React.useState<OpenMode>(OpenMode.NEW);
    const [model, setModel] = React.useState<PackingList>();
    const [loading, setLoading] = React.useState<boolean>(false);
    const [region, setRegion] = React.useState<string>("");
    const [filteredCustomers, setFilteredCustomers] = React.useState<DropDownComboOption[]>([]);
    const [showDescription, setShowDescription] = React.useState<boolean>(true);
    const [showCargoReceivedBy, setShowCargoReceivedBy] = React.useState<boolean>(true);

    const [disableRegionDropDown, setDisableRegionDropDown] = React.useState<boolean>(true);
    const [disablePreviewButton, setDisablePreviewButton] = React.useState<boolean>(true);

    const [totalNetWeightErrorText, setTotalNetWeightErrorText] = React.useState<string>("");
    const [totalGrossWeightErrorText, setTotalGrossWeightErrorText] = React.useState<string>("");

    const [selectedCustomer, setSelectedCustomer] = React.useState<Customer>();

    const [switchPageOnClose, setSwitchPageOnClose] = React.useState<boolean>(false);
    const [saved, setSaved] = React.useState<boolean>(false);

    const [boxSizes, setBoxSizes] = React.useState<BoxSize[]>([]);

    const [selectionModel, setSelectionModel] = React.useState<GridRowId[]>([]);
    const [selectedItem, setSelectedItem] = React.useState<PackingListItem | null>(null);

    const [gridData, setGridData] = React.useState<PackingListItem[]>([]);

    const columnWidth25 = useMemo(() => GetColumnWidth(25, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth35 = useMemo(() => GetColumnWidth(35, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth40 = useMemo(() => GetColumnWidth(40, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth50 = useMemo(() => GetColumnWidth(50, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth55 = useMemo(() => GetColumnWidth(55, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth60 = useMemo(() => GetColumnWidth(60, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth68 = useMemo(() => GetColumnWidth(68, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth70 = useMemo(() => GetColumnWidth(70, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth80 = useMemo(() => GetColumnWidth(80, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth100 = useMemo(() => GetColumnWidth(100, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth120 = useMemo(() => GetColumnWidth(120, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    const columnWidth140 = useMemo(() => GetColumnWidth(140, tinyScreen, smallScreen), [tinyScreen, smallScreen]);
    function GetColumnWidth(width: number, isTiny: boolean, isSmall: boolean) {
      switch (width) {
        case 25:
          return isTiny ? 25 : (isSmall ? 30 : 35);
        case 35:
          return isTiny ? 35 : (isSmall ? 40 : 45);
        case 40:
          return isTiny ? 40 : (isSmall ? 45 : 55);
        case 50:
          return isTiny ? 50 : (isSmall ? 58 : 68);
        case 55:
          return isTiny ? 55 : (isSmall ? 70 : 80);
        case 60:
          return isTiny ? 60 : (isSmall ? 80 : 90);
        case 68:
          return isTiny ? 68 : (isSmall ? 85 : 100);
        case 70:
          return isTiny ? 70 : (isSmall ? 90 : 105);
        case 80:
          return isTiny ? 80 : (isSmall ? 100 : 110);
        case 100:
          return isTiny ? 100 : (isSmall ? 125 : 150);
        case 120:
          return isTiny ? 120 : (isSmall ? 155 : 190);
        case 140:
          return isTiny ? 140 : (isSmall ? 180 : 220);
        default:
          return width;
      }
    }

    //Grid columns
    const columns: GridColumns = [
      {
        field: 'seq', headerName: 'No.', disableColumnMenu: true, 
        width: columnWidth40, minWidth: columnWidth40, 
        type: 'number', editable: true,
        valueSetter: (param: GridValueSetterParams) => onSeqChanged(param),
        preProcessEditCellProps: validateSeqChanged,
        cellClassName: style.NumberTextField
      },
      {
        field: 'cartonNo', headerName: 'C/No.', flex: 1.5, type: 'string', editable: true,
        valueSetter: (param: GridValueSetterParams) => onCellValueChanged(param, "cartonNo", 10),
      },
      {
        field: 'clientPO', headerName: 'Client PO', flex: 2, type: 'string', editable: true,
        valueSetter: (param: GridValueSetterParams) => onCellValueChanged(param, "clientPO", 30),
      },
      {
        field: 'customerPartNo', headerName: 'Part No.', flex: 1.5, type: 'string', editable: true,
        valueSetter: (param: GridValueSetterParams) => onCellValueChanged(param, "customerPartNo", 20),
      },
      { 
        field: 'qty', headerName: '数量', disableColumnMenu: true, sortable: false, 
        width: columnWidth50, minWidth: columnWidth50, 
        type: 'number', editable: true, 
        cellClassName: style.NumberTextField,
        valueFormatter: (param) => FormatNumber(param.value, 0),
        valueSetter: (param: GridValueSetterParams) => onCellValueChanged(param, "qty", 0),
        preProcessEditCellProps: validateQtyChanged
      },
      { 
        field: 'unit', headerName: '单位', disableColumnMenu: true, sortable: false, 
        width: columnWidth40, minWidth: columnWidth40, 
        type: 'string', editable: true,
        valueSetter: (param: GridValueSetterParams) => onCellValueChanged(param, "unit", 10)
      },
      {
        field: 'netWeight', headerName: 'N/W(KG)', disableColumnMenu: true, sortable: false, 
        flex: 1.5, type: 'number', editable: true, align:'right',
        valueGetter: (param) => FormatNumber(param.row.netWeight ?? 0, 2),
        valueSetter: onNetWeightChanged,
        preProcessEditCellProps: validateNumberValueChanged,
        cellClassName: style.NumberTextField
      },
      {
        field: 'grossWeight', headerName: 'G/W(KG)', disableColumnMenu: true, sortable: false, 
        flex: 1.5, type: 'number', editable: true,
        valueGetter: (param) => FormatNumber(param.row.grossWeight ?? 0, 2),
        valueSetter: onGrossWeightChanged,
        preProcessEditCellProps: validateNumberValueChanged,
        cellClassName: style.NumberTextField
      },
      {
        field: 'boxSize', headerName: 'Box Size', disableColumnMenu: true, sortable: false, 
        type: 'string', width: 150, editable: true,
        renderCell: SelectEditInputCell
      },
      {
        field: 'productDesc', headerName: '製品名', flex: 5, type: 'string', minWidth: 100, editable: true,
        valueSetter: (param: GridValueSetterParams) => onCellValueChanged(param, "productDesc", 150),
      },
      { field: 'model', headerName: '型式', flex: 3, type: 'string' }
    ];

    const [searchData, setSearchData] = React.useState<any>({
      pageSize: 10,
    });

    const selectedData = React.useRef<PackingListItem[]>([]);

    function SelectEditInputCell(selectProps: GridRenderCellParams) {
      const { id, value, field } = selectProps;
      const apiRef = useGridApiContext();
    
      const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        let tempGridData = [...gridData];

        let index = tempGridData.findIndex(x => x.id === id);
        if (index > -1) 
        {
          tempGridData[index].boxSize = event.target.value;
          setGridData(tempGridData);
          hasChanges.current = true;
        }
        
        await apiRef.current.setEditCellValue({ id, field, value: event.target.value });
        apiRef.current.setCellMode(id, field, 'view');
      };
    
      const handleDelete = async () => {
        let tempGridData = [...gridData];

        let index = tempGridData.findIndex(x => x.id === id);
        if (index > -1) 
        {
          tempGridData[index].boxSize = '';
          setGridData(tempGridData);
          hasChanges.current = true;
        }
        
        await apiRef.current.setEditCellValue({ id, field, value: '' });
        apiRef.current.setCellMode(id, field, 'view');
      };

      return(
        <TextField
          value={value}
          onChange={handleChange}
          onKeyUp={(event) => {
            if (event.key== 'Delete')
            {
              handleDelete();
            }
          }}          
          variant="standard"
          InputProps={{
            disableUnderline: true
          }}
          select
          fullWidth
        >
          {boxSizes.map((item)=> (
              <MenuItem key={item.boxSizeDescription} value={item.boxSizeDescription}>
                  {item.boxSizeDescription}
              </MenuItem>
          ))}
        </TextField>     
      );
    }


    function onCellValueChanged(param: GridValueSetterParams, field: string, maxLength: number) {
      let row: PackingListItem = param.row;
      Object.entries(row).forEach(([key, value]) => {
        if (`${key}` === field)
        {
          if (maxLength > 0)
            Reflect.set(row, key, param.value.slice(0,maxLength));
          else
            Reflect.set(row, key, param.value);
        }
      });

      let tmpData = gridData;
      let index = tmpData.findIndex(x => x.id === row.id);
      Object.entries(tmpData[index]).forEach(([key, value]) => {
        if (`${key}` === `${field}`)
        {
          if (maxLength > 0)
            Reflect.set(tmpData[index], key, param.value.slice(0,maxLength));
          else
            Reflect.set(tmpData[index], key, param.value);
        }
      });
      setGridData(tmpData);

      hasChanges.current = true;
      return { ...param.row, row };
    }
    
    function onSeqChanged(param: GridValueSetterParams) {
      let row: PackingListItem = param.row;
      let tempGridData = [...gridData];  
      let index = tempGridData.findIndex(x => x.id === row.id);
      let duplicatedRowIndex = tempGridData.findIndex(x => x.seq == param.value);
      if (duplicatedRowIndex > -1)
      {
        //swap sequence no.
        tempGridData[duplicatedRowIndex].seq = tempGridData[index].seq;
      }

      tempGridData[index].seq = param.value;
      setGridData(tempGridData);

      hasChanges.current = true;
      return { ...param.row, row };
    }
        
    function validateSeqChanged(param: GridPreProcessEditCellProps) {
      let errMsg: string = "";

      errMsg = ValidateNumber(param.props.value.toString(), NumberTypes.INTEGER, true);

      if (errMsg !== "")
        showSnackBar(errMsg, "", "error");

      return { ...param.props, error: errMsg !== "" };
    }
    
    function validateQtyChanged(param: GridPreProcessEditCellProps) {
      let errMsg: string = "";

      errMsg = ValidateNumber(param.props.value.toString(), NumberTypes.INTEGER, true);

      if (errMsg !== "")
        showSnackBar(errMsg, "", "error");

      return { ...param.props, error: errMsg !== "" };
    }

    function validateNumberValueChanged(param: GridPreProcessEditCellProps) {
      let errMsg: string = "";

      errMsg = ValidateNumber(param.props.value.toString(), NumberTypes.FLOAT, true);

      if (errMsg !== "")
        showSnackBar(errMsg, "", "error");

      return { ...param.props, error: errMsg !== "" };
    }

    function onNetWeightChanged(param: GridValueSetterParams) {
      let row: PackingListItem = param.row;
      row.netWeight = param.value;

      let totalNetWeight = 0.0;
      let tmpData = gridData;
      tmpData.forEach(x => {
        if (x.id === row.id)
        {
          totalNetWeight += row.netWeight ?? 0;
          x.netWeight = row.netWeight;
        }
        else
          totalNetWeight += x.netWeight ?? 0;
      });
      setGridData(tmpData);

      let temp: any = { ...model };
      temp.totalNetWeight = AwayFromZeroRounding(totalNetWeight,2);      
      setModel(temp);

      hasChanges.current = true;
      return { ...param.row, row };
    }

    function onGrossWeightChanged(param: GridValueSetterParams) {
      let row: PackingListItem = param.row;
      row.grossWeight = param.value;

      let totalGrossWeight = 0.0;
      let tmpData = gridData;
      tmpData.forEach(x => {
        if (x.id === row.id)
        {
          totalGrossWeight += param.value;
          x.grossWeight = param.value;
        }
        else
        totalGrossWeight += x.grossWeight ?? 0;
      });
      setGridData(tmpData);

      let temp: any = { ...model };
      temp.totalGrossWeight = AwayFromZeroRounding(totalGrossWeight,2);
      setModel(temp);

      hasChanges.current = true;
      return { ...param.row, row };
    }


    function CustomToolbar() {
      return (
        <GridToolbarContainer style={{ display: 'flex' }}>
          <Button variant="contained" size="small" color="secondary" style={{ margin: "2px" }} startIcon={<Add />} onClick={() => AddRow()}>Add</Button>
          <div style={{ width: 10 }}></div>
          <Button variant="contained" size="small" color="secondary" style={{ margin: "2px" }} startIcon={<Delete />} onClick={() => DeleteRows()}>Del</Button>
          <div style={{ width: 10 }}></div>
          <Button variant="contained" size="small" color="secondary" style={{ margin: "2px" }} startIcon={<SwitchLeft />} onClick={() => SplitRow()} 
          sx={{visibility : selectedItem ? 'visible' : 'hidden'}}>Split</Button>
        </GridToolbarContainer>
      );
    }

    function AddRow() {
      singleModalRef.current?.Initialise();
    }

    function DeleteRows() {
      if (selectedData.current.length == 0)
      {
        return;
      }
      let tempGridData = [...gridData];
      selectedData.current.forEach(item => {
        let index = tempGridData.findIndex(x => x.lotNo === item.lotNo);
        if (index > -1) {
          tempGridData.splice(index, 1);
        }
      });
      let i = 1;
      tempGridData.forEach(x => {
        x.id = i;
        x.lotNo = i;
        i++
      })
      setGridData(tempGridData);
      let temp = model;
      if (temp) {
        temp.packingListItems = tempGridData;
      }
      setModel(temp);
      setSelectionModel([])
      selectedData.current = [];
    }

    function SplitRow()
    {
      if (selectedItem)
      {
        let selected = {...selectedItem};
        let newGridData: PackingListItem[] = [];
        let tempGridData = [...gridData];
          tempGridData.forEach(item => {
            if (item.lotNo<selected.lotNo)
            {
              newGridData.push({...item});  
            }
            else if (item.lotNo==selected.lotNo)
            {
              newGridData.push({...item});  
              let newItem = {...item};
              newItem.id = item.id + 1;
              newItem.lotNo = item.lotNo + 1;
              newGridData.push(newItem);  
            }
            else if (item.lotNo>selected.lotNo)
            {
              let newItem = {...item};
              newItem.id = item.id + 1;
              newItem.lotNo = item.lotNo + 1;
              newGridData.push(newItem);  
            }
          });
        setGridData(newGridData);
        let temp = model;
        if (temp) {
          temp.packingListItems = tempGridData;
        }
        setModel(temp);
      }
    }

    function AddCustomerAddress() {
      if (selectedCustomer)
        customerAddressModalRef.current?.Initialise(selectedCustomer.customerId);
    }

    function AddCustomerContactPerson() {
      if (selectedCustomer)
        customerContactPersonModalRef.current?.Initialise(selectedCustomer.customerId);
    }

    //Dialogs and snacks
    const hasChanges = React.useRef<boolean>(false);
    const [dialogOpen, setDialogOpen] = React.useState<boolean>(false);
    const [snackSettings, setSnackSettings] =
      React.useState<SnackBarMessageProps>({
        open: false,
        message: "",
        subMessage: "",
        severity: undefined,
        onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
      });

    function showSnackBar(message: string, subMessage: string, colour?: AlertColor) {
      setSnackSettings({
        open: true,
        message: message,
        subMessage: subMessage,
        severity: colour,
        onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
      });
    }

    useImperativeHandle(ref, () => ({
      Initialise(mode: OpenMode, packingList: PackingList) {
        setOpen(true);
        setSelectedItem(null);
        setSaved(false);
        renewToken();
        
        hasChanges.current = false;
        setOpenMode(mode);

        FilterCustomersByLanguage([0]);
        setRegion(GetPackingListRegion(packingList.packingListNo));

        axios.get<BoxSize[]>('Api/V1/BoxSize', {
          headers: {
            'Content-Encoding': 'gzip'
          }
        })
          .then((result) => {
            var netWeight = 0.0;
            var grossWeight = 0.0;
            if (result.data) 
            {
              setBoxSizes(result.data);
              if (mode === OpenMode.NEW)
              {
                setDisableRegionDropDown(false);
                setDisablePreviewButton(true);
              }
              else if (mode === OpenMode.EDIT)
              {
                setDisableRegionDropDown(true);
                setDisablePreviewButton(false);
      
                packingList.packingListItems.forEach(i => {
                  i.id = i.lotNo;
                  netWeight += i.netWeight ?? 0.0;
                  grossWeight += i.grossWeight ?? 0.0;
                });
      
                LoadCustomerInfo(packingList.customerID, packingList.custLangID, packingList.customerName, true);
              } 
              else if (mode === OpenMode.COPY)
              {
                setDisableRegionDropDown(false);
                setDisablePreviewButton(true);
                setSwitchPageOnClose(true);
      
                packingList.packingListItems.forEach(i => {
                  i.id = i.lotNo;
                });
              }
      
              let temp: any = { ...model };
              temp = packingList;
              temp.mobile = "";  
              temp.email = "";
              temp.loginName = "";
              temp.totalNetWeight = mode === OpenMode.EDIT ? netWeight : temp.totalNetWeight;
              temp.totalGrossWeight = mode === OpenMode.EDIT ? grossWeight : temp.totalGrossWeight;
      
              setModel(temp);
      
              setGridData(packingList.packingListItems)
            }
          },
            (error) => {
              console.log(error);
              showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
            }
          )
          .catch((error) => {
            console.log(error);
            showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
          });        
    },
    }));

    function closeModal() {
      setDialogOpen(false);
      setOpen(false);
      props.onClose(false, model!);
    }

    function closeModalCheck(keepOpen: boolean) {
      if (hasChanges.current) {
        setDialogOpen(true);
      } else {
        setDialogOpen(false);
        setOpen(keepOpen);
        props.onClose(switchPageOnClose && saved, model!);
      }
    }

    function isSaveValid(showWarning: boolean) {
      let proceed = true;
      let warning = "";
      let noOfLines = 0;
      if (model) {
        if (model.packingListItems)
        {
          let lotNos = model.packingListItems.map(item => item.lotNo);
          if (HasDuplicates(lotNos)) {
            warning += "Duplicated \'No\' found in packingList items\r\n";
            noOfLines++;
            proceed = false;
          }
        }

        if (model.customerName === "" || model.customerID === 0) {
          warning += "Please select a customer\r\n"
          noOfLines++;
          proceed = false
        }

        if (!proceed && showWarning) {
          showSnackBar(warning.toString(), "", "error");
        }
      }

      return proceed;
    }

    function Update(
      propertyName: string,
      propertyValue: any,
      validationRegex?: RegExp
    ) {
      let proceed = true;

      if (validationRegex !== undefined) {
        proceed = validationRegex.test(propertyValue);
      }

      if (proceed) {
        let temp: any = { ...model };
        
        if (temp[propertyName] != propertyValue)
        {
          hasChanges.current = true;
          temp[propertyName] = propertyValue ?? null;
          setModel(temp);
        }     
      }
    }

    function CustomerChanged(newCustomer: any) {
      if (newCustomer) {
        let custId = newCustomer.value % 100000;
        let custLangId = Math.trunc(newCustomer.value / 100000);
        LoadCustomerInfo(custId, custLangId, newCustomer.name, false);
      }
    }

    function LoadCustomerInfo(customerId: number, custLangId: number, custName: string, isInit: boolean)
    {
      axios.get<Customer>('Api/V1/Customer/' + customerId.toString(), {
        headers: {
          'Content-Encoding': 'gzip'
        }
      })
        .then((result) => {
          if (result.data) 
          {
            setSelectedCustomer(result.data)

            if (!isInit)
            {
              hasChanges.current = true;
              let temp: any = { ...model };
              temp.customerID = customerId;
              temp.customerName = custName;
              temp.custLangID = custLangId;
              temp.attention = result.data.contactPerson;
              temp.phone = result.data.phone1;
              temp.fax = result.data.fax1;
  
              setModel(temp);
            }
          }
        },
          (error) => {
            console.log(error);
            showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
          }
        )
        .catch((error) => {
          console.log(error);
          showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
        });        
    }

    function LanguageChanged(langId: number) {
      hasChanges.current = true;
      let custLangIds = GetCustLangIdsByLanguageId(langId);
      let temp: any = { ...model };
      let availableCustomerLanguageIds: number[] = [];

      for (var i = 1; i <= 3; i++) {
        let index = props.customers.findIndex(s => s.value === ((temp.customerID ?? 1) + i * 100000).toString());
        if (index > 0)
        {
          availableCustomerLanguageIds.push(i);
        }
      }

      let commonLangIds: number[] = custLangIds.filter(function(id) {
        return availableCustomerLanguageIds.indexOf(id) > -1;
      });

      if (commonLangIds.length == 0)
      {
        commonLangIds = availableCustomerLanguageIds;
      }

      let originalId = commonLangIds.find(x => x == model?.custLangID) ?? commonLangIds[0];
      temp.custLangID = originalId;
      temp.languageID = langId;
      setModel(temp);

      FilterCustomersByLanguage([0])
    }

    function FilterCustomersByLanguage(langIds: number[]) {
      let temp: DropDownComboOption[] = props.customers;
      let result: DropDownComboOption[] = [];
      if (langIds.findIndex( x => x === 0) > -1)
      {
        setFilteredCustomers(props.customers);
      } 
      else
      {
        langIds.forEach((id) => {
          result = result.concat(Object.values(temp).filter(c => Math.trunc(parseInt(c.value) / 100000) === id));
        });
        setFilteredCustomers(result);
      }
    }

    function RegionChanged(region: string) {
      hasChanges.current = true;

      axios.get<any[]>(`Api/V1/Branch`, {
        headers: {
          'Content-Encoding': 'gzip'
        }
      })
        .then((result) => {
          let branchSelected: BranchInfo | undefined = result.data.find(b => b.region === region);
          setRegion(region);
          if (branchSelected)
          {
            let temp: any = { ...model };
            let newPackingListNo: string = "";
      
            newPackingListNo = "PL" + branchSelected.japanYear + branchSelected.region + Pad(branchSelected.plNo, 5);
    
            temp["packingListNo"] = newPackingListNo;
    
            setModel(temp);
          }
        },
          (error) => {
            console.log(error);
          }
        )
        .catch((error) => {
          console.log(error);
        });

    }

    function SaveChanges(
      event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
      close: boolean
    ) {
      if (isSaveValid(true)) {
        event.preventDefault();
        event.stopPropagation();

        let m = model;
        if (m)
        {
          m.packingListItems = gridData;
          m.deliveryContact = m.deliveryContact == null ? "" : m.deliveryContact;
          m.deliveryTo = m.deliveryTo == null ? "" : m.deliveryTo;
          m.deliveryPhone = m.deliveryPhone == null ? "" : m.deliveryPhone;
          m.deliveryFax = m.deliveryFax == null ? "" : m.deliveryFax;
          m.displayDescription = m.displayDescription == null ? "" : m.displayDescription;
          m.createDate = moment(m.createDate).format();
          let maxSeq = Math.max(...m.packingListItems.map(item => {return item.seq ?? 1;}));
          let i = 1;
          m.packingListItems.forEach(item => {
            item.lotNo = item.seq ?? maxSeq + i;
            i++;
          });
          setModel(m);
        }
  
        if (openMode === OpenMode.EDIT)
        {
          axios.put<PackingList>('Api/V1/PackingList/', m).then(
            (result) => {
              if (result.data.packingListItems?.length > 0)
              {
                result.data.packingListItems.forEach(i => {
                  i.id = i.lotNo;
                });
  
                setGridData(result.data.packingListItems)
              }              
  
              let temp: any = { ...model };
              temp = result.data;
              temp.mobile = ""; //mobile cannot be null when save  
              temp.email = ""; //email cannot be null when save
              temp.loginName = ""; //loginName cannot be null when save
              setModel(temp);
  
              showSnackBar("Packing list saved successfully.", "", "success");
              hasChanges.current = false;
              setOpen(!close);
              setDialogOpen(false);
            },
            (error) => {
              console.log(error);
              showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
            }
          );
        } 
        else
        {
          axios.post<PackingList>('Api/V1/PackingList/', m).then(
            (result) => {
              if (result.data.packingListItems?.length > 0)
              {
                result.data.packingListItems.forEach(i => {
                  i.id = i.lotNo;
                });
  
                setGridData(result.data.packingListItems)
              }
  
              let temp: any = { ...model };
              temp = result.data;
              temp.mobile = ""; //mobile cannot be null when save  
              temp.email = ""; //email cannot be null when save
              temp.loginName = ""; //loginName cannot be null when save
              temp.address = ""; //address cannot be null when save
              setModel(temp);
  
              showSnackBar("Packing list created successfully.", "", "success");

              hasChanges.current = false;
              setSaved(true);
              setDisableRegionDropDown(true);
              setDisablePreviewButton(false);
              setOpenMode(OpenMode.EDIT);
              setOpen(!close);
              setDialogOpen(false);
            },
            (error) => {
              console.log(error);
              showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
            }
          );
        }
      }
    }

    function Preview(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
      let m = model;
      if (m)
        viewerModalRef.current?.Initialise(m.packingListNo, showDescription, showCargoReceivedBy);
    }

    function PopulateSelectedProducts(hasSelection: boolean, productItems: React.MutableRefObject<ProductListItem[]>)
    {
      if (!hasSelection)
        return;

      let newQoutationItems: PackingListItem[] = [];
      let m = model;
      if (m) {
        let lotNos: number[] | undefined = m?.packingListItems?.map(i => i.lotNo);

        let maxLotNo: number = 1;
        if (lotNos && lotNos.length>0)
        {
          maxLotNo = Math.max(...lotNos) + 1;
        }

        productItems.current.forEach((item) => {
          let calculatedPrice = (item.price ?? 0) * 0.7 * (m?.exRate ?? 0);
          let productDescription: string = "";
          switch (m?.languageID ?? 1) {
            case 1:
              productDescription = item.nameEng ?? (item.nameChi ?? (item.nameJpn ?? ""));
              break;
            case 2:
              productDescription = item.nameJpn ?? (item.nameChi ?? (item.nameEng ?? ""));
              break;
            case 3:
              productDescription = item.nameChi ?? (item.nameJpn ?? (item.nameEng ?? ""));
              break;
            case 4:
              productDescription = (item.nameEng ?? "") + " " + (item.nameChi ?? "");
              break;
            case 5:
              productDescription = (item.nameEng ?? "") + " " + (item.nameJpn ?? "");
              break;
            case 6:
              productDescription = (item.nameChi ?? "") + " " + (item.nameJpn ?? "");
              break;
            }

          const packingListItem: PackingListItem = {
            id: maxLotNo,
            packingListNo: m?.packingListNo ?? "",
            lotNo: maxLotNo,
            productID: item.productID,
            productDesc: productDescription,
            cartonNo: "",
            clientPO: item.customerPO,
            customerPartNo: "",
            qty: item.minOrderQty ?? 1,
            unit: item.unit,
            netWeight: item.netWeight,
            grossWeight: item.netWeight,
            boxSize: "",
            invoiceNo: "",
            model: item.model ?? "",
            seq: maxLotNo
          };
          newQoutationItems.push(packingListItem);
          maxLotNo++;
        })

        let tempData = [...gridData, ...newQoutationItems];
        setGridData(tempData);

        m.packingListItems = tempData;
        setModel(m);
        hasChanges.current = true;
      }

    }

    function FillCustomerAddress(hasSelection: boolean, customerAddressItem: React.MutableRefObject<CustomerAddressItem>)
    {
      if (!hasSelection)
        return;

        Update("deliveryAddress", customerAddressItem.current.address);
    }

    function FillCustomerContactPerson(hasSelection: boolean, customerContactPersonItem: React.MutableRefObject<CustomerContactPersonItem>)
    {
      if (!hasSelection)
        return;

        Update("attention", customerContactPersonItem.current.contactPerson);
    }

    return (
      <div>
        <Modal open={open} onClose={() => closeModalCheck(true)}>
          <div className={style.ModalMain}>
            {model && !loading ? (
              <div className={style.ModalBody}>
                <Title pageTitle="Packing List" />
                <div className={style.ModalContent}>
                  <div className={style.ModalFields}>
                    <CustomDropDown1 className={style.ModalContentField} 
                      dropDownBoxWidth={tinyScreen ? "70px" : (smallScreen ? "85px" : "100px")}
                      firstTextBoxWidth={tinyScreen ? "calc(100% - 70px)" : (smallScreen ? "calc(100% - 85px)" : "calc(100% - 100px)")}
                      firstTextBoxMinWidth={tinyScreen ? "174px" : (smallScreen ? "260px" : "375px")}
                      dropDownBoxId="region-dropdown" dropDownBoxLabel="Region" dropDownBoxDisabled={disableRegionDropDown}
                      firstTextBoxLabel="Packing List No" firstTextBoxName="txtPackingListNo"
                      dropDownBoxValue={region} dropDownBoxOptions={props.regions}
                      firstTextBoxValue={model.packingListNo}
                      onSelectionChanged={RegionChanged} />
                    <div className={style.ModalContentField}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                    >
                      <div className={style.ModalInnerContentFieldOneThirdWidthLeft} 
                        style={{ minWidth: tinyScreen ? "110px" : (smallScreen ? "140px" : "170px") }}
                      >
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            key="createDate"
                            label="Create Date"
                            inputFormat="yyyy/MM/dd"
                            mask="____/__/__"
                            value={Date.parse(model.createDate)}
                            onChange={(newValue) => Update("createDate", moment(newValue).format('YYYY/MM/DD'))}
                            renderInput={(params) => <TextField {...params} sx={{ width: '100%' }} size="small" />}
                          />
                        </LocalizationProvider>
                      </div>
                      <TextField className={style.ModalInnerContentFieldTwoThirdWidthRight}
                        value={model.languageID}
                        onChange={(e) => LanguageChanged(parseInt(e.target.value))}
                        select
                        label="Language"
                        size="small"
                      >
                        {Languages.map((item) => (
                          <MenuItem key={item.id} value={item.id}>{item.value}</MenuItem>
                        ))}
                      </TextField>
                    </div>
                    <Autocomplete className={style.ModalContentField}
                        limitTags={2}
                        onChange={(e, selected) => CustomerChanged(selected)}
                        options={filteredCustomers}
                        getOptionLabel={(option: DropDownComboOption) => option.name}
                        renderOption={(props, option) => {
                          return (
                            <li {...props} key={option.value}>
                              {option.name}
                            </li>
                          );
                        }}
                        value={filteredCustomers.find(s => s.value === (model.customerID + model.custLangID * 100000).toString()) || null}
                        style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label={"Customer"}
                            size="small"
                          />
                        )}
                        size="small"
                      />
                    <TextField className={style.ModalContentField} 
                      value={model.attention}
                      label="Attention"
                      onChange={(e) => Update("attention", e.target.value.slice(0,30))}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={(e) => AddCustomerContactPerson()}><Add /></IconButton>
                          </InputAdornment>
                        ),
                      }}
                      size="small"
                    />   
                  </div>
                  <div className={style.ModalFields}>
                    <TextField className={style.ModalContentField}
                      value={model.invoiceNo}
                      label="Invoice No."
                      onChange={(e) => Update("invoiceNo", e.target.value.slice(0,90))}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      size="small"
                    />
                    <TextField className={style.ModalContentField}
                      value={model.arrivalDate}
                      label="Arrival Date"
                      onChange={(e) => Update("arrivalDate", e.target.value.slice(0,26))}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      size="small"
                    />
                    <TextField className={style.ModalContentField} 
                      value={model.deliveryAddress}
                      label="Ship To"
                      onChange={(e) => Update("deliveryAddress", e.target.value.slice(0,250))}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      multiline
                      rows={GetNoOfLines(model.deliveryAddress)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={(e) => AddCustomerAddress()}><Add /></IconButton>
                          </InputAdornment>
                        ),
                      }}                        
                      size="small"
                    />
                    <div className={style.ModalContentField}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                    >
                      <TextField className={style.ModalInnerContentFieldLeft}
                        value={model.phone}
                        label="Telephone"
                        onChange={(e) => Update("phone", e.target.value.slice(0,25))}
                        size="small"
                      />
                      <TextField className={style.ModalInnerContentFieldRight}
                        value={model.fax}
                        label="Fax"
                        onChange={(e) => Update("fax", e.target.value.slice(0,25))}
                        size="small"
                      />
                    </div>
                  </div>
                  <div className={style.PageContent} style={{ minHeight: "325px" }}>
                    <DataGridPro
                      getRowId={(row) => row.id}
                      rows={gridData}
                      columns={columns}
                      pageSize={searchData.pageSize}
                      onPageSizeChange={(pageSize) => setSearchData({ ...searchData, pageSize: pageSize })}
                      pagination
                      rowsPerPageOptions={[10, 20, 40]}
                      loading={loading}
                      checkboxSelection
                      components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomTablePagination
                      }}
                      componentsProps={{
                        footer: { rowsPerPageOptions: [10, 20, 40] }
                      }}
                      selectionModel = {selectionModel}
                      onSelectionModelChange={(selections) => {
                        setSelectionModel(selections)
                        const ids = new Set(selections);
                        const selectedRows = gridData.filter((row) => ids.has(row.lotNo));
                        selectedData.current = selectedRows;
                      }}
                      disableSelectionOnClick={true}
                      onRowClick = {(param) => {
                        setSelectedItem(param.row);
                      }}
                      headerHeight={tinyScreen ? 28 : (smallScreen ? 32 : 36)}
                      rowHeight={tinyScreen ? 20 : (smallScreen ? 24 : 28)}
                    />
                  </div>
                  <div className={style.ModalFields}>
                    <TextField className={style.ModalContentField}
                      value={model.totalCarton}
                      label="Carton Total"
                      onChange={(e) => Update("totalCarton", e.target.value.slice(0,100))}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      size="small"
                    />
                    <TextField className={style.ModalContentField}
                      value={model.totalQty}
                      label="Quantity Total"
                      onChange={(e) => Update("totalQty", e.target.value.slice(0,50))}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      size="small"
                    />
                    <NumberFormat className={`${style.ModalContentField} ${style.NumberTextField}`} 
                      customInput={TextField}
                      value={model.totalNetWeight}
                      label="Total Net Weight"
                      error={totalNetWeightErrorText !== ""}
                      helperText={totalNetWeightErrorText}
                      decimalScale={2}
                      thousandSeparator
                      onValueChange={(e) => {
                        if (e.value !== "")
                        {
                          let msg = ValidateNumber(e.value, NumberTypes.FLOAT, true);
                          setTotalNetWeightErrorText(msg);
                          if (msg === "")
                            Update("totalNetWeight", e.value);
                        }
                      }}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      size="small"
                    />
                    <NumberFormat className={`${style.ModalContentField} ${style.NumberTextField}`} 
                      customInput={TextField}
                      value={model.totalGrossWeight}
                      label="Total Gross Weight"
                      error={totalGrossWeightErrorText !== ""}
                      helperText={totalGrossWeightErrorText}
                      decimalScale={2}
                      thousandSeparator
                      onValueChange={(e) => {
                        if (e.value !== "")
                        {
                          let msg = ValidateNumber(e.value, NumberTypes.FLOAT, true);
                          setTotalGrossWeightErrorText(msg);
                          if (msg === "")
                            Update("totalGrossWeight", e.value);
                        }
                      }}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      size="small"
                    />
                  </div>
                  <div className={style.ModalFields}>
                    <TextField className={style.ModalContentField}
                      value={model.shipBy}
                      label="Ship By"
                      onChange={(e) => Update("shipBy", e.target.value.slice(0,150))}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      rows={GetNoOfLines(model.shipBy)}
                      multiline
                      size="small"
                    />
                    <TextField className={style.ModalContentField}
                      value={model.caseMark}
                      label="Case Mark"
                      onChange={(e) => Update("caseMark", e.target.value.slice(0,250))}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      rows={GetNoOfLines(model.caseMark)}
                      multiline
                      size="small"
                    />
                    <TextField className={style.ModalContentFieldHalfWidth}
                      value={model.remark}
                      label="Remark"
                      onChange={(e) => Update("remark", e.target.value.slice(0,250))}
                      style={{ minWidth: tinyScreen ? "244px" : (smallScreen ? "344px" : "464px") }}
                      rows={GetNoOfLines(model.remark)}
                      multiline
                      size="small"
                    />
                  </div>
                </div>

                <div className={style.ModalFooter}>
                  <FormControlLabel
                    control={
                      <Checkbox checked={showDescription} onChange={(e) => setShowDescription(e.target.checked)} />
                    }
                    label="Show Description"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox checked={showCargoReceivedBy} onChange={(e) => setShowCargoReceivedBy(e.target.checked)} />
                    }
                    label="Show Cargo Received By"
                  />
                  <Button
                    variant="contained"
                    color="secondary"
                    className={style.margin}
                    onClick={(e) => SaveChanges(e, false)}
                  >
                    Save
                  </Button>
                  <Button
                    variant="contained"
                    color="secondary"
                    className={style.margin}
                    disabled={disablePreviewButton}
                    onClick={(e) => Preview(e)}
                  >
                    Preview
                  </Button>
                  <Button
                    variant="contained"
                    className={style.margin}
                    onClick={(e) => closeModalCheck(false)}
                  >
                    Close
                  </Button>
                </div>

              </div>
            ) : (
              <div style={{ textAlign: "center" }}>
                <CircularProgress color="primary" />
              </div>
            )}
          </div>
        </Modal>

        <SnackBarMessage {...snackSettings} />

        <GeneralDialog
          title={"Save Changes?"}
          message={
            "Changes have been made, did you want to save before closing?"
          }
          open={dialogOpen}
          options={[
            {
              text: "Save",
              action: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => SaveChanges(event, true),
              color: "secondary",
              variant: "contained",
            },
            {
              text: "No",
              action: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => closeModal(),
              color: "primary",
              variant: "contained",
            },
          ]}
        />

        <ProductList
          ref={singleModalRef}
          onClose={(hasSelection: boolean, productItems: React.MutableRefObject<ProductListItem[]>) => PopulateSelectedProducts(hasSelection, productItems)}
        />

        <PackingListViewer ref={viewerModalRef} onClose={()=>{}}/>

        <CustomerAddress 
          ref={customerAddressModalRef} 
          onClose={(hasSelection: boolean, customerAddressItem: React.MutableRefObject<CustomerAddressItem>) => FillCustomerAddress(hasSelection, customerAddressItem)} />

        <CustomerContactPerson 
          ref={customerContactPersonModalRef} 
          onClose={(hasSelection: boolean, customerContactPersonItem: React.MutableRefObject<CustomerContactPersonItem>) => FillCustomerContactPerson(hasSelection, customerContactPersonItem)} />
      </div>
    );


  }

);
